import BScroll from "@better-scroll/core";
import { defineComponent, reactive, onMounted } from "vue";
export default defineComponent({
  props: ["good"],

  setup(props) {
    let bscroll = reactive({});
    onMounted(() => {
      const wrapper = document.getElementById("wrapper");
      bscroll = new BScroll(wrapper, {
        // movable: true
        probeType: 3,
        click: true
      });
    });
    return {
      bscroll,
      goods: props.good
    };
  }

});